import { classNames } from '@commenda/utils';
import { Icons } from '../../Icons';

export const SortIndicator = ({
  direction,
  onClick,
}: {
  direction: 'asc' | 'desc' | null;
  onClick: ((event: unknown) => void) | undefined;
}) => {
  const iconClassNames = 'shrink-0 size-3 text-inherit cursor-pointer';

  return (
    <button
      type="button"
      className={classNames(
        'size-4 rounded-xs flex justify-center items-center transition-all duration-200',
        direction === 'asc' || direction === 'desc'
          ? 'bg-bg-brand hover:bg-bg-brand-hover text-fg-brand hover:text-fg-brand-hover'
          : 'bg-bg-primary hover:bg-bg-primary-hover text-fg-quaternary hover:text-fg-quaternary-hover'
      )}
      aria-label="Toggle sort"
      onClick={onClick}
    >
      {direction === 'asc' ? (
        <Icons.ArrowUp className={iconClassNames} />
      ) : direction === 'desc' ? (
        <Icons.ArrowDown className={iconClassNames} />
      ) : (
        <Icons.ArrowUp className={iconClassNames} />
      )}
    </button>
  );
};
